import { PathPickerType } from "../types/enums";
import { Factory } from "./Factory";

export const ContentContext = React.createContext({
  breadcrumbs: [],
  content: [],
  onBreadcrumbClick: () => {},
  onItemSelect: () => {},
  selected: [],
  fetchContent: () => {},
  fetchChildrenByFilter: () => {},
  fetchTreeChildren: () => {},
  fetchBreadcrumbs: () => {},
  setProperty: () => {},
  doSearch: () => {},
  fetchPreferences: () => {},
  searchQuery: '',
  sort: true,
  sortByValue: 'cm:name',
  page: 1,
  total: 0,
  pageSize: 50,
  filter: '',
  type: PathPickerType.ALL,
  multiSelect: false,
  currentSite: Factory.GET_EMPTY_SITE(),
  searchMode: false,
  hidden: {},
  loadingContent: false,
  favouriteDocuments: {},
  favouriteFolders: {},
});

export const TreeContext = React.createContext({
  treeItems: {},
  currentSite: Factory.GET_EMPTY_SITE(),
  fetchContent: () => {},
  fetchTreeChildren: () => {},
  fetchBreadcrumbs: () => {},
  selected: [],
  loadingItem: '',
  breadcrumbs: [],
  searchMode: false,
});